export default __webpack_public_path__ + "static/media/Logo.5a9de29f.svg";